import BookCTA from "@/components/BookCTA";

const AnyaStory = () => {
  const results = [
    { label: "Paying customers", value: "470" },
    { label: "Monthly recurring revenue", value: "₹16.8L (~$20K)" },
    { label: "Raised", value: "₹50L (~$60K)" },
    { label: "Customer retention", value: "92%" },
    { label: "Team of", value: "5" },
  ];

  return (
    <section className="container mx-auto px-4 sm:px-6 lg:px-8 mb-20">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
        {/* Left — Story */}
        <div>
          <h2 className="text-3xl sm:text-4xl font-black text-foreground tracking-tight mb-2">
            From paralyzed to profitable in 18 months.
          </h2>
          <p className="text-sm font-medium text-muted-foreground uppercase tracking-[0.08em] mb-6">
            A story inspired by founders we've worked with.
          </p>
          <p className="text-lg text-muted-foreground mb-6 leading-relaxed">
            Anya had the idea. She had the drive. What she didn't have was a team, a budget, or a technical co-founder. What she found instead was a sequence. The right prompts, used at the right stage, changed everything.
          </p>
          <blockquote className="brutal-border border-l-4 border-t-0 border-b-0 border-r-0 border-l-primary pl-6 py-2 mb-6">
            <p className="text-lg font-bold text-foreground italic">
              "She didn't find a secret growth hack. She found the right prompts — in the right order."
            </p>
          </blockquote>
          <BookCTA variant="link">Read the full story →</BookCTA>
        </div>

        {/* Right — Stats card */}
        <div className="brutal-border brutal-shadow bg-foreground text-background rounded-md p-8">
          <h3 className="font-black text-xl mb-6 uppercase tracking-[0.08em]">Anya's Results</h3>
          <div className="space-y-4">
            {results.map((r) => (
              <div key={r.label} className="flex items-center justify-between border-b border-background/20 pb-3 last:border-0 last:pb-0">
                <span className="text-sm font-medium opacity-80">{r.label}</span>
                <span className="text-2xl font-black">{r.value}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AnyaStory;
